import React from 'react';
import ReactDOM from 'react-dom';
import { PropTypes } from 'prop-types';

import './Modal.css';

const Modal = ({
  isShowing, hide, innerComponent, title, showHeader,
}) => (isShowing ? ReactDOM.createPortal(
  <>
    <div className="modal-overlay" />
    <div className="modal-wrapper" aria-modal aria-hidden tabIndex={-1} role="dialog">
      <div className="modal">
        { showHeader ? (
          <div className="modal-header">
            <button type="button" className="modal-close-button" aria-label="Close" onClick={hide}>
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        ) : ''}
        <div className="modal-title">{title}</div>
        {innerComponent}
      </div>
    </div>
  </>,
  document.body,
)
  : null);

Modal.propTypes = {
  isShowing: PropTypes.bool,
  hide: PropTypes.func,
  innerComponent: PropTypes.element,
  title: PropTypes.string,
  showHeader: PropTypes.bool,
};

Modal.defaultProps = {
  isShowing: false,
  showHeader: true,
  title: '',
  hide: null,
  innerComponent: null,
};

export default Modal;
